import React, { PropsWithChildren, useCallback, useState } from "react";
import PermissionContext from "./PermissionContext";
import {  Component, Feature, IUserPermissionDTO, PermissionType, UserPermissionDTO } from "../../services/generated";

export interface IUserPayload extends PropsWithChildren {
    id: any,
    userPermissions?: UserPermissionDTO[] | null
}

const PermissionProvider = ({
    children
}: PropsWithChildren) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const[hasAccess, setHasAccess] = useState(false);
    let global: any = globalThis;
    const updateUser = (newUser: IUserPayload) => {
        global.accessDetails = JSON.stringify(newUser)

    };
    
    const isAuthorized = useCallback((feature? : Feature,
        component? : Component, permission? : PermissionType): boolean => {
        
        let hasAuthorization: boolean = false;
        let global: any = globalThis;

        const storedUser = JSON.parse(Object.freeze(global.accessDetails) || '{}');

        setIsLoading(true)
        setHasAccess(false);
        if(storedUser) {
            hasAuthorization = CheckUserHasRolesOrPermissions(storedUser, feature, component, permission)
        }
        setIsLoading(false)
        return hasAuthorization
    }, []);

    const CheckHasPermission = (requiredPermission: PermissionType, testedPermission: PermissionType) : Boolean => {
        switch(requiredPermission) {
            case PermissionType.View:
                return [PermissionType.View, PermissionType.Edit].includes(testedPermission);
            case PermissionType.Edit:
                return testedPermission === PermissionType.Edit;
        }
    }

    const CheckUserHasRolesOrPermissions = (storedUser: IUserPayload, 
        feature? : Feature, component? : Component, permission? : PermissionType): boolean => {
        let hasPermissions: boolean = false;

        const ups: IUserPermissionDTO[] = storedUser.userPermissions?.map(
            (x: any) => ({
              appUserId: x.appUserId,
              feature: x.feature,
              component: x.component,
              permission: x.permission,
            })) as IUserPermissionDTO[];

        hasPermissions = ups.filter(x => x.feature === feature
        &&  x.component === component
        && (CheckHasPermission(permission!, x.permission!))
        ).length > 0;
        if(hasPermissions) {
            setHasAccess(true);
        }
        return hasPermissions
    };

    const getUserAllowedOptions = useCallback((feature? : Feature,
        component? : Component, permission? : PermissionType, keyName? : string): Array<number> => {
        let global: any = globalThis;
        const storedUser = JSON.parse(Object.freeze(global.accessDetails) || '{}');
        let allowedValues: Array<number> = [];
        const userAllowedOptions = storedUser.userPermissions?.filter(
        (x: any) => (x.feature === feature && x.component === component && x.permission === permission
        ));
        if(userAllowedOptions.length > 0) {
            allowedValues = userAllowedOptions[0][keyName!];
        }
        return allowedValues.sort();
    }, []);

    return <PermissionContext.Provider value={{
        setUser: updateUser,
        isAuthorized,
        getUserAllowedOptions,
        isLoading,
        hasAccess
    }}>{children}
    </PermissionContext.Provider>;
};

export default PermissionProvider;